import React from 'react';
import { motion } from 'framer-motion';

function FooterSection() {
  return (
    <section id="更多信息" className="section footer-sec" aria-labelledby="footer-title" style={{
      background: '#FFFFFF',
      padding: 'var(--space-16) var(--space-8)',
      position: 'relative'
    }}>
      <div className="container text-center" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <motion.h2
          id="footer-title"
          className="section-heading"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          style={{
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            fontWeight: '700',
            color: '#2C2C2C',
            fontFamily: 'serif',
            marginBottom: 'var(--space-12)',
            textAlign: 'center'
          }}
        >
          更多信息
        </motion.h2>
        <div className="links" role="navigation" aria-label="外部链接" style={{
          display: 'flex',
          justifyContent: 'center',
          gap: 'var(--space-8)',
          flexWrap: 'wrap'
        }}>
          <motion.a 
            href="https://yulinsec.github.io/wiki" 
            className="link" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="访问工作室 Wiki"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            whileHover={{ y: -4 }}
            style={{
              display: 'inline-block',
              padding: 'var(--space-4) var(--space-8)',
              color: '#8B4513',
              fontSize: '1.1rem',
              fontWeight: '600',
              textDecoration: 'none',
              transition: 'all 0.3s ease',
              fontFamily: 'serif'
            }}
          >
            工作室 Wiki
          </motion.a>
          <motion.a 
            href="https://yulinsec.github.io/blog" 
            className="link" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="访问成员博客"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            whileHover={{ y: -4 }}
            style={{
              display: 'inline-block',
              padding: 'var(--space-4) var(--space-8)',
              color: '#CD5C5C',
              fontSize: '1.1rem',
              fontWeight: '600',
              textDecoration: 'none',
              transition: 'all 0.3s ease',
              fontFamily: 'serif'
            }}
          >
            成员博客
          </motion.a>
          <motion.a 
            href="https://mp.weixin.qq.com/s/your-wechat" 
            className="link" 
            target="_blank" 
            rel="noopener noreferrer"
            aria-label="访问微信公众号"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
            whileHover={{ y: -4 }}
            style={{
              display: 'inline-block',
              padding: 'var(--space-4) var(--space-8)',
              color: '#DAA520',
              fontSize: '1.1rem',
              fontWeight: '600',
              textDecoration: 'none',
              transition: 'all 0.3s ease',
              fontFamily: 'serif'
            }}
          >
            微信公众号
          </motion.a>
        </div>
      </div>
    </section>
  );
}

export default FooterSection;